const LOAD_DATA_NOTIFICATION           = 'LOAD_DATA_NOTIFICATION'
const LOAD_DATA_NOTIFICATION_SUCCESS   = 'LOAD_DATA_NOTIFICATION_SUCCESS'
const LOAD_DATA_NOTIFICATION_FAILED    = 'LOAD_DATA_NOTIFICATION_FAILED'
const UNMOUNT_DATA_NOTIFICATION        = 'UNMOUNT_DATA_NOTIFICATION'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const notificationReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_NOTIFICATION:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_NOTIFICATION_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_NOTIFICATION_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_NOTIFICATION:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default notificationReducer;